import React from 'react'
import {GatsbyImage, getImage} from 'gatsby-plugin-image'
import parse from 'html-react-parser'

const TeamValues = ({ items }) => {

  return (
    <section className="team-values">
      <div className='team-values__items'>
        { items?.map((el, index) => (
            <div key={index} className="team-values__item">
              <div className="team-values__inner">
                <GatsbyImage className='team-values__image' image={getImage(el.image.localFile)} alt={el.image.altText}/>
                <div className="team-values__content">
                  <span className='team-values__number'>{index + 1}</span>
                  { el.title && <h4>{parse(el.title)}</h4> }
                  { el.content && <div>{parse(el.content)}</div> }
                </div>
              </div>
            </div>
          ))
        }
      </div>
    </section>
  );
};

export default TeamValues